import { pathJoin } from 'src/reducers/routing/utils'

export const createDetailRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  'related-customers': pathJoin(prefix)('related-customers').chain,
  properties: pathJoin(prefix)('properties').chain,
  authorizations: pathJoin(prefix)('authorizations').chain,
  tickets: pathJoin(prefix)('tickets').chain,
  notes: pathJoin(prefix)('notes').chain,
  details: pathJoin(prefix)('details').chain,
})
